import React from "react";
import MainLandingPage from "./components/Home/MainLanding";

function Home() {
  return (
    <div>
      <MainLandingPage />
    </div>
  );
}

export default Home;
